import { Surfaces } from "@netlify/sdk--ui-core";
import React from "react";
import { useNetlifySDK } from "../../use_netlify_sdk.js";

export type SiteConfigurationSurfaceProps = {
  className?: string | undefined;
  children?: React.ReactNode | undefined;
};

/**
 * A container element used to render the top-level Project Configuration surface. This component
 * will take care of styling your component so it looks good as a project section listed under the
 * top-level navigation for projects in the Netlify UI.
 *
 * <!-- TODO(ndhoule): Add a screenshot here -->
 *
 * @param props
 * @see Surfaces.SiteConfiguration
 * @example
 * ```tsx
 * import { SiteConfigurationSurface } from "@netlify/sdk/react/components";
 *
 * <SiteConfigurationSurface>
 *   <div>Your surface content goes here</div>
 * </SiteConfigurationSurface>
 * ```
 */
export const SiteConfigurationSurface = ({
  className,
  children,
  ...otherProps
}: SiteConfigurationSurfaceProps) => {
  const sdk = useNetlifySDK();

  return (
    <section
      id={`section-${Surfaces.SiteConfiguration}-${sdk.extension.slug}`}
      className={className}
      {...otherProps}
    >
      {children}
    </section>
  );
};
